import { TableSchema } from "./index";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { sizing } from "../../utils/methods";

type TableHeaderProps = {
  schema: TableSchema<any>[];
};

const TableHeader = ({ schema }: TableHeaderProps) => {
  return (
    <TableHead>
      <TableRow>
        {schema.map((value, index) => (
          <TableCell
            key={index}
            sx={{
              padding: sizing(6),
              paddingLeft: sizing(0),
              fontWeight: 500,
              fontFamily: "IBM Mono",
              ...value.headerStyle,
            }}
          >
            {value.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default TableHeader;
